import { configureStore } from '@reduxjs/toolkit'
import teacherReducer from './states/docente'
import authSlice from './states/authSlice'

export const store = configureStore({
	reducer: {
		teacher: teacherReducer,
		auth: authSlice,
	},
})
